import { Show } from "solid-js";
import { Title } from "@solidjs/meta";
import { Banner } from "~/common/banner";
import { Button } from "~/common/button";
import { Form, InputField } from "~/common/form";
import { useForm } from "~/inertia";
import { completeUserConfirmationPath, newUserSessionPath } from "~/routes";
import { AuthPageLayout, AuthPageLink } from "./_layout";

type Props = {
  confirmationToken: string;
  strings: {
    title: string;
    body: string;
    passwordLabel: string;
    confirmPasswordLabel: string;
    passwordHint: string | null;
    submit: string;
  };
};

type FormData = {
  confirmationToken: string;
  password: string;
  passwordConfirmation: string;
  base?: never;
};

export default function CompleteConversion(props: Props) {
  const form = useForm<FormData>({
    // eslint-disable-next-line solid/reactivity -- token is fixed for the page's lifetime
    confirmationToken: props.confirmationToken,
    password: "",
    passwordConfirmation: "",
  });

  return (
    <AuthPageLayout>
      <Title>{props.strings.title}</Title>

      <div class="space-y-2">
        <h1 class="text-2xl font-semibold">{props.strings.title}</h1>
        <p class="text-sm text-typography-secondary">{props.strings.body}</p>
      </div>

      <Form
        class="space-y-6"
        onSubmit={(e) => {
          e.preventDefault();
          form.put(completeUserConfirmationPath());
        }}
      >
        <Show when={form.errors.base?.length}>
          <Banner variant="error" description={form.errors.base!.join(", ")} />
        </Show>

        <InputField
          label={props.strings.passwordLabel}
          type="password"
          required
          autofocus
          autocomplete="new-password"
          description={props.strings.passwordHint ?? undefined}
          value={form.data.password}
          errors={form.errors.password}
          onChange={(e) => form.setData("password", e.target.value)}
        />

        <InputField
          label={props.strings.confirmPasswordLabel}
          type="password"
          required
          autocomplete="new-password"
          value={form.data.passwordConfirmation}
          errors={form.errors.passwordConfirmation}
          onChange={(e) => form.setData("passwordConfirmation", e.target.value)}
        />

        <Button
          type="submit"
          variant="primary"
          size="lg"
          width="full"
          class="mt-12"
          loading={form.processing}
        >
          {props.strings.submit}
        </Button>
      </Form>

      <AuthPageLink href={newUserSessionPath()}>Back to sign in</AuthPageLink>
    </AuthPageLayout>
  );
}
